export default {
  'app.setting.pagestyle': 'Seitenstil-Einstellung',
  'app.setting.pagestyle.dark': 'Dunkler Stil',
  'app.setting.pagestyle.light': 'Heller Stil',
  'app.setting.content-width': 'Inhaltsbreite',
  'app.setting.content-width.fixed': 'Fest',
  'app.setting.content-width.fluid': 'Fließend',
  'app.setting.themecolor': 'Theme-Farbe',
  'app.setting.themecolor.dust': 'Staubrot',
  'app.setting.themecolor.volcano': 'Vulkan',
  'app.setting.themecolor.sunset': 'Sonnenuntergang Orange',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Polargrün',
  'app.setting.themecolor.daybreak': 'Tagesanbruch Blau (Standard)',
  'app.setting.themecolor.geekblue': 'Geek Blau',
  'app.setting.themecolor.purple': 'Goldenes Lila',
  'app.setting.navigationmode': 'Navigationsmodus',
  'app.setting.sidemenu': 'Seitenmenü-Layout',
  'app.setting.topmenu': 'Oberes Menü-Layout',
  'app.setting.fixedheader': 'Feste Kopfzeile',
  'app.setting.fixedsidebar': 'Feste Seitenleiste',
  'app.setting.fixedsidebar.hint': 'Funktioniert im Seitenmenü-Layout',
  'app.setting.hideheader': 'Kopfzeile beim Scrollen ausblenden',
  'app.setting.hideheader.hint': 'Funktioniert wenn ausgeblendete Kopfzeile aktiviert ist',
  'app.setting.othersettings': 'Weitere Einstellungen',
  'app.setting.weakmode': 'Farbenblind-freundlicher Modus',
  'app.setting.copy': 'Einstellung kopieren',
  'app.setting.copyinfo':
    'Kopieren erfolgreich, bitte ersetzen Sie defaultSettings in src/models/setting.js',
  'app.setting.production.hint':
    'Einstellungsbereich wird nur in der Entwicklungsumgebung angezeigt, bitte manuell ändern',
};